import { Text } from '@fluentui/react-components';
import clsx from 'clsx';
import { FC, PropsWithChildren, useLayoutEffect, useRef, useState } from 'react';
import './EllipsisText.scss';

export interface EllipsisTextProps {
    hover?: boolean;
    selected?: boolean;
}
export const EllipsisText: FC<PropsWithChildren<EllipsisTextProps>> = (props: PropsWithChildren<EllipsisTextProps>) => {
    const { children, hover, selected } = props;
    const textRef = useRef<HTMLSpanElement>(null);
    const [isEllipsis, setIsEllipsis] = useState<boolean>();

    useLayoutEffect(() => {
        if ((hover || selected) && textRef.current && textRef.current.parentElement) {
            const isCut = textRef.current.offsetWidth > textRef.current.parentElement.offsetWidth;
            setIsEllipsis(isCut);
            if (isCut) {
                const shift = textRef.current.parentElement.offsetWidth - (textRef.current.offsetWidth + 5);
                const time = (Math.abs(shift) / 8) * 400;
                document.body.style.setProperty('--EllipsisTextShift', `${shift}px`);
                document.body.style.setProperty('--EllipsisTextTime', `${time}ms`);
            }
        }
    }, [children, hover, selected]);

    return (
        <div className={clsx('ellipsisText', (selected || hover) && isEllipsis ? 'hover' : '')}>
            <span ref={textRef} className="ellipsisText__content">{children}</span>
        </div>
    );
};
